export default __webpack_public_path__ + "static/media/FAQ_10_2.83e12a47.png";